var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecretSanta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 128 128",
    fill: "none",
    "aria-label": "Secret Santa white icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 35C60 20 77 17 91 25c10 6 14 15 15 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 39c15-6 31-6 47 2",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 50,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 61,
    width: 76,
    height: 43,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 48,
    width: 82,
    height: 18,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 48v56M26 66h76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 49c-8-14-25-15-25-6 0 8 13 12 25 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 49c8-14 25-15 25-6 0 8-13 12-25 10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 50,
    r: 4,
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 82l-10-4 4 9-8 6 12 1 4 9 3-11",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 88c1-8 7-12 14-12l-3 8 6 5-10 2",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 92,
    r: 2.8,
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 95,
    r: 2.8,
    fill: "#FFFFFF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 99,
    r: 2.8,
    fill: "#FFFFFF",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretSanta);
export default __webpack_public_path__ + "static/media/SecretSanta.54d2634545e3487a52d46d729698afe8.svg";
export { ForwardRef as ReactComponent };